

import React, { useState, useEffect, useContext } from 'react';
import {useStyle} from '../../context/styleContext/styleContext'
import axios from 'axios'
import {toast} from 'react-hot-toast'
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
  Paper,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import ChangePasswordModal from "./ChangePasswordModal";
import{UserContext} from '../../context/userContext/userContext'
import Seo from '../../components/Seo';
export default function Account(){

const { setUserEmail } = useContext(UserContext);
const countryList = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica", "Côte d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czechia (Czech Republic)", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini (fmr. \"Swaziland\")", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Holy See", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar (formerly Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"];
const [userData, setUserData] = useState({
        userName: "",
        email: "",
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        phone: "", 
        okToEmail: false,    
        })

const [originalData, setOriginalData] = useState({
            userName: "",
            email: "",
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            phone: "", 
            okToEmail: false,    
            })

const [formData, setFormData] = useState({
            userName: "",
            email: "",
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            phone: "", 
            okToEmail: false,    
            })


const [pageIsLoading, setPageIsLoading] = useState(true)
const [dataIsModified, setDataIsModified] = useState(false)
const { style, setStyle } = useStyle();
const navigate = useNavigate();
useEffect(() => {getAccountInfo();}, []);

const [userNameAlert, setUserNameAlert] = useState("")
const [emailAlert, setEmailAlert] = useState("")
const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
  const openPasswordModal = () => setPasswordModalOpen(true);
  const closePasswordModal = () => setPasswordModalOpen(false);

const navToLogin = () => {
    setPageIsLoading(false);
    navigate('/login');
  };

const navToSubscriptions = () => {
  setPageIsLoading(false);
  navigate('/manage-subscriptions');
};

  const isUnchanged =
  originalData.userName === formData.userName &&
  originalData.email === formData.email &&
  originalData.firstName === formData.firstName &&
  originalData.lastName === formData.lastName &&
  originalData.address1 === formData.address1 &&
  originalData.address2 === formData.address2 &&
  originalData.city === formData.city &&
  originalData.state === formData.state &&
  originalData.zip === formData.zip &&
  originalData.country === formData.country &&
  originalData.phone === formData.phone &&
  originalData.okToEmail == formData.okToEmail;


const getAccountInfo = async (e) => {   
    
        setPageIsLoading(true)
    
        try{
    
            const token = localStorage.getItem('token')
            const dataToSend = {token: token}
    
            if(token)
            {
    
            const{data} = await axios.post('/accountinfo', dataToSend)
    
            if(data.error){
                toast.error(data.error)
            }
            else{
    
                const newFormData = 
                {
                    token:token,
                    userName:data.userName,
                    email:data.email,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    address1: data.address1,
                    address2: data.address2,
                    city: data.city,
                    state: data.state,
                    zip: data.zip,
                    country: data.country,
                    phone: data.phone, 
                    okToEmail: data.okToEmail,  
                }
    
                //await setUserData(newFormData)
                await setOriginalData(newFormData)
                await setFormData(newFormData)
               // await setOriginalData(newFormData)    
                await setPageIsLoading(false)
            }
    
    
        }
        
    
        }catch(error){
            console.log(error)
        }
    }



const submitChanges = async (e) => {
        
        e.preventDefault();
        setPageIsLoading(true);

        const token = localStorage.getItem('token')
        if(!token)
        {
            //kick to login page if there is no token (only happens if token  has been deleted after the page loaded for some reason)
            navToLogin()
            return
        }
        //console.log("THIS SHOULDN'T CLICK")
        const dataToSend = 
            {
                token:token,
                userName:formData.userName,
                email:formData.email,
                firstName: formData.firstName,
                lastName: formData.lastName,
                address1: formData.address1,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zip: formData.zip,
                country: formData.country,
                phone: formData.phone, 
                okToEmail: formData.okToEmail,  
            }

        try {
            const response = await axios.patch('/account', dataToSend);
            const statusCode = response.status;
            const data = response.data;
            await setUserEmail(formData.email.toLowerCase())
            if (data.error) {
                toast.error(data.error);
            } else {
                await setOriginalData(dataToSend);
                await setFormData(dataToSend);
                await setPageIsLoading(false);
                localStorage.setItem('token', data.token);
                toast.success('Account Information Updated!');
            }
        } catch (error) {
            // Axios errors contain response info
            if (error.response) {
                const field = error.response.data.errorField;
                if(field === 'email')
                {
                    setOriginalData(formData);
                    setEmailAlert(error.response.data.error)
                }
                if(field === 'userName')
                {
                    setOriginalData(formData);
                    setUserNameAlert(error.response.data.error)
                }
                toast.error(error.response.data?.error || 'Update failed');
                setPageIsLoading(false);
            } else {
                toast.error('Update failed');
            }
        }

    };

    const changeUserName = (e) => {

        setUserNameAlert(false)
        handleChange(e);
    }
    const changeEmail = (e) => {

        setEmailAlert(false)
        handleChange(e);
    }


      const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
          ...formData,
          [name]: type === 'checkbox' ? checked : value,
        });
      };
    
      const handlePhoneChange = (newValue) => {
        setFormData({
          ...formData,
          phone: newValue,
        });
      };
    
    
      return (
<>

<Seo
  title="Account | Parish Audio"
  description="Manage your Parish Audio account information, purchases, subscriptions, and plugin access."
  canonical="https://parishaudio.com/account"
  robots="noindex,follow"
/>
        <Box
          sx={{
            backgroundColor: 'black',
            minHeight: '100vh',
            color: 'rgb(221, 230, 237)',
            py: 2,
            px: 4,
          }}
        >
            {pageIsLoading && (
                <LoadingSpinner />

            )}
            {!pageIsLoading && (

<Paper
            elevation={6}
            sx={{
              backgroundColor: 'rgb(39, 55, 77)',
              padding: 3,
              maxWidth: 800,
              margin: 'auto',
              borderRadius: 3,
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ color: 'rgb(221, 230, 237)' }}>
              My Account
            </Typography>
            <Grid container spacing={2}>
              {/* Username + Email */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="userName"
                  label="Username"
                  size="small"
                  variant="outlined"
                  value={formData.userName}
                  onChange={changeUserName}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em',
                    },
                  }}
                  sx={{
                    // Autofill fix
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
                <div style={{color:'red', textAlign:'center'}}>{userNameAlert}</div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="email"
                  label="Email"
                  size="small"
                  variant="outlined"
                  value={formData.email}
                  onChange={changeEmail}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em',
                    },
                  }}
                  sx={{
                    // Autofill fix
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
                <div style={{color:'red', textAlign:'center'}}>{emailAlert}</div>
              </Grid>
    
              {/* First Name + Last Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="firstName"
                  label="First Name"
                  size="small"
                  variant="outlined"
                  value={formData.firstName}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em'
                    },
                  }}
                  sx={{
                    
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="lastName"
                  label="Last Name"
                  size="small"
                  variant="outlined"
                  value={formData.lastName}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em'
                    },
                  }}
                  sx={{
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
    
              {/* Address 1 (Full Width) */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="address1"
                  label="Address 1"
                  variant="outlined"
                  size="small"
                  value={formData.address1}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em',
                    },
                  }}
                  sx={{
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
    
              {/* Address 2 (Full Width) */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  name="address2"
                  label="Address 2"
                  variant="outlined"
                  size="small"
                  value={formData.address2}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em'
                    },
                  }}
                  sx={{
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
    
              {/* City + State */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="city"
                  label="City"
                  variant="outlined"
                  size="small"
                  value={formData.city}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em'
                    },
                  }}
                  sx={{
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="state"
                  label="State/Province"
                  variant="outlined"
                  size="small"
                  value={formData.state}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em'
                    },
                  }}
                  sx={{
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="zip"
                  label="Zip / Postal Code"
                  variant="outlined"
                  size="small"
                  value={formData.zip}
                  onChange={handleChange}
                  InputLabelProps={{ style: { color: style.color3 } }}
                  InputProps={{
                    style: {
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 6,
                      fontSize:'1.2em'
                    },
                  }}
                  sx={{
                    boxShadow:10,
                    'input:-webkit-autofill': {
                      WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                      WebkitTextFillColor: style.color4,
                      caretColor: 'white',
                    },
                    // Focused border color
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: style.color2, // default border color
                      },
                      '&:hover fieldset': {
                        borderColor: style.color2, // hover border color
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: style.color3, // focused border color
                      },
                    },
                  }}
                />
              </Grid>
    
              {/* Country + Phone */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={{boxShadow:10, borderColor:style.color3}}>
                  <InputLabel sx={{ color: 'rgb(221, 230, 237)' }}>Country</InputLabel>
                  <Select
                    name="country"
                    value={formData.country}
                    size="small"
                    onChange={handleChange}
                    sx={{
                      color: 'rgb(221, 230, 237)',
                      backgroundColor: 'rgb(82, 109, 130)',
                      borderRadius: 1,
                      fontSize:'1.2em',
                      
                  }}
                  >
                    {countryList.map((country) => (
                      <MenuItem key={country} value={country}>
                        {country}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
    
              <Grid item xs={12} sm={6}>
              <MuiTelInput
                fullWidth
                label="Phone Number"
                defaultCountry="US"
                size="small"
                value={formData.phone}
                onChange={handlePhoneChange}
                sx={{
                    '& .MuiInputBase-root': {
                    color: 'rgb(221, 230, 237)',
                    backgroundColor: 'rgb(82, 109, 130)',
                    borderRadius: '6px',
                    fontSize:'1.2em',
                    boxShadow:10,
                    },
                    '& .MuiInputLabel-root': {
                    color: 'rgb(221, 230, 237)',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'transparent',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgb(157, 178, 191)',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgb(221, 230, 237)',
                    color:style.color3,
                    },

                        'input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0px 1000px rgb(82, 109, 130) inset',
                        WebkitTextFillColor: style.color4,
                        caretColor: 'white',
                        },
                }}
                />
                                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.okToEmail}
                      onChange={handleChange}
                      name="okToEmail"
                      sx={{
                        color: 'rgb(157, 178, 191)',
                        '&.Mui-checked': {
                          color: 'rgb(157, 178, 191)',
                        },
                      }}
                    />
                  }
                  label="YES, please email me with promotions and discounts"
                  sx={{ mt:3, color: 'rgb(221, 230, 237)' }}
                />
              </Grid>
    
              {/* Marketing Opt-in */}
              <Grid item xs={12}>

                {!isUnchanged  && (
                    <Button
                  variant="contained"
                  onClick={submitChanges}
                  sx={{
                    backgroundColor: 'rgb(157, 178, 191)',
                    minWidth:'225px',
                    color: 'black',
                    boxShadow:10,
                    '&:hover': {
                      backgroundColor: 'rgb(221, 230, 237)',
                    },
                  }}
                >
                  Save Changes
                </Button>

                )}
                {isUnchanged  && (
                    <Button
                  variant="contained"
                  disabled
                  onClick={submitChanges}
                  sx={{
                    backgroundColor: 'rgb(157, 178, 191)',
                    minWidth:'225px',
                    color: 'black',
                    '&:hover': {
                      backgroundColor: 'rgb(221, 230, 237)',
                    },
                  }}
                >
                  Save Changes
                </Button>

                )} 
              </Grid>





              {/* Buttons */}
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}><Button
                  variant="outlined"
                  color="inherit"
                  onClick={navToSubscriptions}
                  sx={{
                    borderColor: 'rgb(157, 178, 191)',
                    color: 'rgb(221, 230, 237)',
                    minWidth:'225px',
                    boxShadow:10,
                    '&:hover': {
                      backgroundColor: 'rgb(82, 109, 130)',
                    },
                  }}
                >
                  Manage Subscriptions
                </Button></Grid>
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={setPasswordModalOpen.bind(null, true)}
                  sx={{
                    borderColor: 'rgb(157, 178, 191)',
                    color: 'rgb(221, 230, 237)',
                    minWidth:'225px',
                    boxShadow:10,
                    '&:hover': {
                      backgroundColor: 'rgb(82, 109, 130)',
                    },
                  }}
                >
                  Change Password
                </Button>
                  
              </Grid>
             
            </Grid>
          </Paper>

            )}
          
        </Box>
        <div id='modal-root'>
            <ChangePasswordModal isOpen={isPasswordModalOpen} close={closePasswordModal} />
                
        </div>
       </>
      );
};






// import {React, useState, useContext, useEffect} from "react"
// import{UserContext} from '../../context/userContext/userContext'
// import { useStyle } from '../../context/styleContext/styleContext';
// import axios from 'axios'
// import {toast} from 'react-hot-toast'
// import Button from '@mui/material/Button';
// import ReactGA from 'react-ga4';
// //import { FOCUSABLE_SELECTOR } from "@testing-library/user-event/dist/utils";
// import ChangePasswordModal from "./ChangePasswordModal";
// import ChangeStripeEmailModal from "./ChangeStripeEmailModal";
// //import Terms from "../Terms/Terms"
// import { Checkbox, TextField, FormGroup, FormControlLabel } from "@mui/material";
// import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";



// export default function Account(){

//   const { user } = useContext(UserContext);
//   const { style, setStyle } = useStyle();
//   const [isPageLoading, setIsPageLoading] = useState(false);

//   const [isPasswordModalOpen, setPasswordModalOpen] = useState(false);
//   const openPasswordModal = () => setPasswordModalOpen(true);
//   const closePasswordModal = () => setPasswordModalOpen(false);

//   const [isStripeEmailModalOpen, setStripeEmailModalOpen] = useState(false);
//   const openStripeEmailModal = () => setStripeEmailModalOpen(true);
//   const closeStripeEmailModal  = () => setStripeEmailModalOpen(false);

//   useEffect(() => {getAccountInfo();}, []); // pull list when screen loads
//   useEffect(() => {update();}, [])

//   const [height, setHeight] = useState(window.innerHeight)
//   const [width, setWidth] = useState(window.setWidth)

//   useEffect(() => {
//     function handleResize() {      
//       setWidth(window.innerWidth)
//       setHeight(window.innerHeight)
//   }
  
//     window.addEventListener('resize', handleResize)
//   })



//     ReactGA.send({
//         hitType:"pageview",
//         page:"account",
//         title:"account",
//     })

//     useEffect(() => {
//     document.title = 'Parish Audio | State Of The Art State Of The Art Audio Processing | Account';
//     }, []);
  
//     // const [userData, setUserData] = useState({
//     // email: "",
//     // firstName: "",
//     // lastName: "",
//     // okToEmail: false,    
//     // })

//     let userToken = ""
//     if(localStorage.getItem('token'))
//     {
//         userToken = localStorage.getItem('token')
//     }

//     const [formData, setFormData] = useState({
//     email:"",
//     firstName: "",
//     lastName: "",
//     okToEmail: false,
//     token:userToken,
//     })

//     const [originalData, setOriginalData] = useState({
//         email:"",
//         firstName: "",
//         lastName: "",
//         okToEmail: false,
//         token:userToken,
//         })
    
//     const [imgData, setImgData] = useState({
//         profileImage: "",
//         })



//     const handleSubmit = async (e) => {
//         e.preventDefault();        
//     }


//     const saveNewImgUriToDB = async (imgURI) => {

//         console.log("submit!")

//         console.log('imgURI: ', imgURI)
    
//         try {
//             const { data } = await axios.patch(`/update_profile_pic/${imgURI}`);
//             if (data.error) {
//                 toast.error(data.error);
//             } else {
    
//                 await getAccountInfo();
//                 edit.activated = false
//                 toast.success('Account Information Updated!');
//             }
//         } catch (error) {
//             console.error(error);
//             toast.error('Update failed');
//         }
//     };

//     const [edit, setEdit] = useState({
//         activated : false
//     })

    
//   const changeBackground = () => {
//     setStyle({ ...style, backgroundColor: 'rgb(0,255,0)' });
//   };

//   const fire = () => {
//     console.log("FIRE!!!!!!")
//     console.log("form data x")
//     console.log(formData)
//     console.log("O Data: ")
//     console.log(originalData)
//   };

//   const toggleEditMode = async (e) => {
//     if(edit.activated){
//         setEdit({ ...edit, activated: false });
//     }
//     else{
//         setEdit({ ...edit, activated: true });
//     }


//   }

//   const cancel = async (e) => {

//     if(edit.activated){
//         setEdit({ ...edit, activated: false });
//     }
//     else{
//         setEdit({ ...edit, activated: true });
//     }
//   }

//   const update = async (e) => {

//   } 
  


//   const getAccountInfo = async (e) => {   
    
//     setIsPageLoading(true)

//     try{

//         const token = localStorage.getItem('token')
//         const dataToSend = {token: token}

//         if(token)
//         {

//         const{data} = await axios.post('/accountinfo', dataToSend)

//         if(data.error){
//             toast.error(data.error)
//         }
//         else{

//             const newFormData = 
//             {
//                 email:data.email,
//                 firstName:data.firstName,
//                 lastName:data.lastName,
//                 okToEmail:data.okToEmail,
//                 token:token
//             }

//             await setFormData(newFormData)
//             await setOriginalData(newFormData)    
//             await setIsPageLoading(false)
//         }


//     }
    

//     }catch(error){
//         console.log(error)
//     }
// }




//   const submitChanges = async (e) => {
    
//     e.preventDefault();
//     await setIsPageLoading(true);

//     console.log("submitting changes")
//     console.log("form data:")
//     console.log(formData)


//     try {
//         const { data } = await axios.patch('/account', formData);
//         if (data.error) {
//             toast.error(data.error);
//         } else {
            
//             const newFormData = 
//             {
//                 email:formData.email,
//                 firstName:formData.firstName,
//                 lastName:formData.lastName,
//                 okToEmail:formData.okToEmail,
//                 token:formData.token,
//             }

//             await setFormData(newFormData)
//             await setOriginalData(newFormData)    
//             await setIsPageLoading(false)
//             toast.success('Account Information Updated!');

//         }
//     } catch (error) {
//         console.error(error);
//         //setIsPageLoading(false);
//         toast.error('Update failed');
//     }
// };

//     return(
//         <>          

//     {isPageLoading &&(<div style={{minHeight:height - 130, alignContent:'center'}}><LoadingSpinner /></div>)}
//     {!isPageLoading &&(


// <div style={{display:'flex', flexDirection:'column', width:'100%'}}>

// <div style={{display:'flex', flexDirection:'column', width:'90%', maxWidth:'600px', margin:'auto', color:style.color1, textAlign:'center', marginTop:'40px', backgroundColor:style.color4, borderRadius:'10px', borderStyle:'solid', borderColor:style.color1}}>
//     <div style={{width:'90%', margin:'auto'}}>

    
//         <div style={{display:'flex', flex:1, textAlign:'center', marginTop:'20px'}}>
//             <h1 style={{flex:1, textAlign:'center', margin:'auto', marginBottom:'40px'}}>
//                 Account Information
//             </h1>
           
//         </div>

//         <div style={{maxWidth:'400px', margin:'auto'}}>
//         <div style={{display:'flex', flex:1, textAlign:'center'}}>
//             <h4 style={{flex:1, textAlign:'left', margin:'auto', color:style.color1}}>
//                 <div style={{marginBottom:'5px'}}>
                
//                 <TextField
//                 id="outlined-basic"
//                 label="Email"
//                 variant="outlined"
//                 value={formData.email}
//                 size='small'
//                 fullWidth
//                 fontSize='14px'
//                 sx={{
//                     backgroundColor: style.color3,
//                     '& .MuiInputBase-input': {
//                     color: style.color1,  // Change the font color here
//                     fontSize: '14px',  // Change the font size here
//                     },
//                     '& .MuiOutlinedInput-root': {
//                     '& fieldset': {
//                         color: style.color1,
//                         borderColor: style.color1, // Change the border color if needed
//                         borderWidth:'2px'
//                     },
//                     '&:hover fieldset': {
//                         borderColor: style.color1, // Change the border color on hover if needed
//                     },
//                     '&.Mui-focused fieldset': {
//                         borderColor: style.color1, // Change the border color when focused if needed
//                     },
//                     '&.Mui-disabled': {
//                         '& fieldset': {
//                         borderColor: style.color1, // Change the border color when disabled
//                         backgroundColor: style.color3
//                         },
//                     },
//                     },
//                     '& .MuiInputLabel-root': {
//                     color: style.color1, // Change the label color here
//                     fontSize:'14pt',
//                     },
//                     '& .MuiInputLabel-root.Mui-focused': {
//                     color: style.color1, // Change the label color when focused here
//                     },
//                     '& .MuiInputLabel-root.Mui-disabled': {
//                     color: style.color1, // Change the label color when disabled
//                     },
//                     '& .MuiInputBase-root.Mui-disabled': {
//                     '& input': {
//                         color: style.color1, // Change the input font color when disabled // so it works in safari
//                         WebkitTextFillColor: style.color1, // so it works on chrome
//                         fontSize:'14pt'
//                     },
//                     },
//                     '& .MuiOutlinedInput-input': { color: style.color1,
//                     '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(157, 178, 191) inset',
//             WebkitTextFillColor: style.color1, color:style.color1
//          }, }, 
//                 }}
//                 />

//                 </div>
//                 </h4>
//         </div>
//         <div style={{display:'flex', flex:1, textAlign:'center', marginBottom:'10px'}}> 
//         <FormGroup>
//             <FormControlLabel checked={formData.okToEmail} onChange={(e) => setFormData({ ...formData, okToEmail: e.target.checked }) } control={<Checkbox size='large' sx={{color:style.color1, '&.Mui-checked': {
//                 color: style.color1,
//             },}} />} label="Subscribe to Emails" />
//         </FormGroup>
//         </div>
//         <div style={{display:'flex', flex:1, textAlign:'center', padding:'0px', justifyContent:'top', margin:'auto', marginBottom:'50px'}}>
//                 <Button onClick={setPasswordModalOpen.bind(null, true)} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color2, margin:'auto', fontSize:'14pt', width:'100%', minWidth:'250px', maxWidth:'250px', padding:'5px', borderColor:style.color1, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color3 }, }}>Change Password</Button>
//         </div>
//         <div style={{display:'flex', flex:1, textAlign:'center', marginBottom:'20px'}}>
//         <TextField
//                 id="outlined-basic"
//                 label="First Name"
//                 variant="outlined"
//                 value= {formData.firstName}
//                 onChange={(e) => setFormData({...formData, firstName: e.target.value})}
//                 size='small'
//                 fullWidth
//                 sx={{
//                     backgroundColor: style.color3,
//                     borderRadius:'4px',
//                     '& .MuiInputBase-input': {
//                     color: style.color1,  // Change the font color here
//                     fontSize: '14pt',  // Change the font size here
                                                    
//                     },
//                     '& .MuiOutlinedInput-root': {
//                     '& fieldset': {
//                         borderColor: style.color1, // Change the border color if needed
//                         borderWidth:'2px'
//                     },
//                     '&:hover fieldset': {
//                         borderColor: style.color1, // Change the border color on hover if needed\
//                         borderWidth:'3px',                                                               
                 
                        
//                     },
//                     '&.Mui-focused fieldset': {
//                         borderColor: style.color1, // Change the border color when focused if needed
//                         borderWidth:'3px'
                        
//                     },
//                     '&.Mui-disabled': {
//                         '& fieldset': {
//                         borderColor: style.color1, // Change the border color when disabled
//                         },
//                     },
//                     },
//                     '& .MuiInputLabel-root': {
//                     color: style.color2, // Change the label color here
//                     fontSize:'14pt',
//                     },
//                     '& .MuiInputLabel-root.Mui-focused': {
//                     color: style.color1, // Change the label color when focused here                                 
//                     },
//                     '& .MuiInputLabel-root.Mui-disabled': {
//                     color: style.color1, // Change the label color when disabled
//                     },
//                     '& .MuiInputBase-root.Mui-disabled': {
//                     '& input': {
//                         color: style.color1, // Change the input font color when disabled // so it works in safari
//                         WebkitTextFillColor: style.color1, // so it works on chrome
//                         fontSize:'14pt'
//                     },
//                     },
//                     '& .MuiOutlinedInput-input': { color: style.color1,
//         '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(157, 178, 191) inset',
//             WebkitTextFillColor: style.color1, color:style.color1
//          }, }, 
//                 }}
//                 />
//         </div>

//         <div style={{display:'flex', flex:1, textAlign:'center', marginBottom:'15px'}}>
//         <TextField
//                 id="outlined-basic"
//                 label="Last Name"
//                 variant="outlined"
//                 value= {formData.lastName}
//                 onChange={(e) => setFormData({...formData, lastName: e.target.value})}
//                 size='small'
//                 fullWidth
//                 sx={{
//                     backgroundColor: style.color3,
//                     borderRadius:'4px',
//                     '& .MuiInputBase-input': {
//                     color: style.color1,  // Change the font color here
//                     fontSize: '14pt',  // Change the font size here
                    
//                     },
//                     '& .MuiOutlinedInput-root': {
//                     '& fieldset': {
//                         borderColor: style.color1, // Change the border color if needed
//                         borderWidth:'2px'
//                     },
//                     '&:hover fieldset': {
//                         borderColor: style.color1, // Change the border color on hover if needed\
//                         borderWidth:'3px'
                 
                        
//                     },
//                     '&.Mui-focused fieldset': {
//                         borderColor: style.color1, // Change the border color when focused if needed
//                         borderWidth:'3px'
                        
//                     },
//                     '&.Mui-disabled': {
//                         '& fieldset': {
//                         borderColor: style.color1, // Change the border color when disabled
//                         },
//                     },
//                     },
//                     '& .MuiInputLabel-root': {

                    
//                     color: style.color2, // Change the label color here
//                     fontSize:'14pt',
//                     },
//                     '& .MuiInputLabel-root.Mui-focused': {
//                     color: style.color1, // Change the label color when focused here
//                     },
//                     '& .MuiInputLabel-root.Mui-disabled': {
//                     color: style.color1, // Change the label color when disabled
//                     },
//                     '& .MuiInputBase-root.Mui-disabled': {
//                     '& input': {
//                         color: style.color1, // Change the input font color when disabled // so it works in safari
//                         WebkitTextFillColor: style.color1, // so it works on chrome
//                         fontSize:'14pt'
//                     },
//                     },
//                     '& .MuiOutlinedInput-input': { color: style.color1,
//         '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(157, 178, 191) inset',
//             WebkitTextFillColor: style.color1, color:style.color1
//          }, }, 
//                 }}
//                 />

        
//         </div>

//         {(formData.firstName != originalData.firstName || formData.lastName != originalData.lastName || formData.okToEmail != originalData.okToEmail) &&(
//         <div style={{marginTop:'50px', marginBottom:'50px', display:'flex', flex:1}}>
//             <Button onClick={submitChanges} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color2, fontSize:'14pt', width:'100%', maxWidth:'250px', minWidth:'250px', margin:'auto', marginTop:'0px', borderColor:style.color1, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color4 }, }}>Submit Changes</Button>
//         </div>
//         )}
//         {(formData.firstName === originalData.firstName && formData.lastName === originalData.lastName && formData.okToEmail === originalData.okToEmail) &&(
//         <div style={{marginTop:'50px', marginBottom:'50px', display:'flex', flex:1}}>
//             <Button disabled onClick={submitChanges} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color5, fontSize:'14pt', width:'100%', maxWidth:'250px', minWidth:'250px', margin:'auto', marginTop:'0px', borderColor:style.color3, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color4 }, }}>Submit Changes</Button>
//         </div>
//         )}                          




//     </div>

//     </div>

// </div>
// <div id='modal-root'>
// <ChangePasswordModal isOpen={isPasswordModalOpen} close={closePasswordModal} />
    
// </div>


// </div>


//     )}

        
//         </>

//     )
// }